(function($){

class cx_app
{

	constructor()
	{
		this.load();
		this.actions();
	}

	load()
	{

		// Homepage
		
		$(".home .slider").flexslider({
			controlNav: false,
			directionNav: false
		});
		
		//Add scroll effect to rows
		window.sr = ScrollReveal();

		let $page_content_rows = $(".cx_page_content .row").not(".vc_tta-panel-body .row");

		sr.reveal($page_content_rows);
		sr.reveal('.cx_home_content .row');
		
		// On The Ground - Maps
		
		if ($("body.on_the_ground").is("*")){
			// Responsive Image Maps
			// rwdImageMaps jQuery plugin v1.6 - https://raw.githubusercontent.com/stowball/jQuery-rwdImageMaps/master/jquery.rwdImageMaps.min.js
			;(function(a){a.fn.rwdImageMaps=function(){var c=this;var b=function(){c.each(function(){if(typeof(a(this).attr("usemap"))=="undefined"){return}var e=this,d=a(e);a("<img />").on('load',function(){var g="width",m="height",n=d.attr(g),j=d.attr(m);if(!n||!j){var o=new Image();o.src=d.attr("src");if(!n){n=o.width}if(!j){j=o.height}}var f=d.width()/100,k=d.height()/100,i=d.attr("usemap").replace("#",""),l="coords";a('map[name="'+i+'"]').find("area").each(function(){var r=a(this);if(!r.data(l)){r.data(l,r.attr(l))}var q=r.data(l).split(","),p=new Array(q.length);for(var h=0;h<p.length;++h){if(h%2===0){p[h]=parseInt(((q[h]/n)*100)*f)}else{p[h]=parseInt(((q[h]/j)*100)*k)}}r.attr(l,p.toString())})}).attr("src",d.attr("src"))})};a(window).resize(b).trigger("resize");return this}})(jQuery);
			$("img[usemap]").rwdImageMaps();
		}
		
		$(".map-slider-container.west").appendTo($(".west-container"));
		$(".map-slider-container.central").appendTo($(".central-container"));
		$(".map-slider-container.east").appendTo($(".east-container"));
		$(".map-slider-container .map-slider").flexslider({
			controlNav: true,
			directionNav: true,
			animation: "slide",
			slideshow: false
		});
		
		
		// Work With Us
		$(".employee-slider").flexslider({
			animation: "slide",
			controlNav: true,
			directionNav: false
		});
		
	}

	actions()
	{

		$(document).bind('gform_confirmation_loaded', function(event, formId){
			console.log('confirmation loaded');
		});
	  
		$(".navbar li.dropdown > a").click(function(e){
			if ($(window).width() < 992){
				e.preventDefault();
				e.stopImmediatePropagation();
				if ($(this).parent("li").hasClass("children-opened")){
					$(this).next("ul.dropdown-menu").hide();
				} else {
					$(this).next("ul.dropdown-menu").show();
				}
				$(this).parent("li").toggleClass("children-opened");
			}
		});
	  
		$(document).on('click', '.vc_tta-panel-title a', (event) => {
			this.accordion($(event.target));
		});


		$(document).on('click', '.gform_button', (event) => {
		$(event.target).text("...");
			
		function timeout() {
    	setTimeout(function () {
		if($("div.validation_error").length != 0)
		{
		timeout();
		}
		else
		{
			$(event.target).text("Success");
		}
    	}, 1000);
		}
	
		});

		/*gform.addFilter( 'gform_spinner_target_elem', function( $targetElem, formId ) {
			console.log('ran');
   			 return $( '.button' ); 
		} );*/
    
    	$(document).on('change', '.gfield_select', (event) => {
			 if(event.target.selectedIndex === 0){
				$(event.target).css("color", "#C5C7C8");
			} else {
				$(event.target).css("color", "#231F20");
			}
		});
		
		$(".home .flex-caption .btn").click(function(){
			var dest = $(this).attr("href");
			$("html, body").animate({ scrollTop: $(dest).offset().top - 175 }, 500);
		});

		
		// On The Ground - Maps
		
		$(".map-slider-container .close-btn").click(function(e){
			$(this).parent(".map-slider-container").removeClass("active");
			return false;
		});
		
		$(".on_the_ground map area").click(function(e){
			var sliderClass = $(this).attr("class");
			
			// If already active, close
			if ($(".map-slider-container." + sliderClass).hasClass("active")){
				$(".map-slider-container." + sliderClass).removeClass("active");
				return false;
			}
			
			$(".map-slider-container").removeClass("active");
			$(".map-slider-container." + sliderClass).addClass("active");
			
			mapAdjustments();
			
			return false;
		});
		
		// Workaround - image maps not working for hidden tabs
		$(".vc_tta-tab").click(function(){
			setTimeout(
				function(){
					$("img[usemap]").rwdImageMaps();
			}, 250);
			
		});
		
		// Mobile links - trigger <area> click action
		$(".mobile-stations ul li a").click(function(){
			$(".on_the_ground map area." + $(this).attr("class")).trigger("click");
			return false;
		});
		
		function mapAdjustments(){
			
			if ($(".map-slider-container.active").is("*") == false){
				return false;
			}
			
			// Calculate center coordinates of map area (circle pins)
			var mapName = $(".map-slider-container.active").data("name");
			var loc = $(".map-slider-container.active").data("location");
			var container = "." + loc + "-container";
			var i = 0, coords = $(".map-container area." + mapName).attr("coords").split(",");
			var maxX = 0,
			minX = Infinity,
			maxY = 0,
			minY = Infinity;
			
			while (i < coords.length) {
				var x = parseInt(coords[i++],10),
				y = parseInt(coords[i++],10);

				if (x < minX) minX = x;
				else if (x > maxX) maxX = x;

				if (y < minY) minY = y;
				else if (y > maxY) maxY = y;
			}
			
			// Calculate triangle offset to point to lineup with center coordinates determined above
			var dotCenter = minX + (maxX - minX) / 2;
			var triangleWidth = 76;
			var triangleHeight = 38;
			var triangleOffset = dotCenter - (triangleWidth / 2);
			
			var topOffset = $(container).outerHeight() + triangleHeight + 40;
			$(".map-triangle").css("left", triangleOffset + "px");
			$(".map-slider-container.active").css({"top" : topOffset + "px"});
		}
		
		$(window).resize(function(){
			
			mapAdjustments();
			
		});
		
		
		// Work With Us
		
		$(".employee-slider .next-btn").click(function(){
			$(".employee-slider").flexslider("next");
			return false;
		});
		
		if ($("body.page-work-with-us").is("*")){
			var employeeSlider = $(".employee-slider").html();
			$("body.page-work-with-us .cx_accordion .vc_tta-panel-title a").click(function(){
				if ($(this).find(".vc_tta-title-text").text().trim() == "Employee Spotlight"){
					setTimeout(
						function(){
							$(".employee-slider").resize();
						}, 250
					);
				}
			});
		}
		
		$(".navbar-toggler").click(function(){
			$("body").toggleClass("mobile-nav-open");
		});
		
	}

	accordion($elem)
	{
		let $altelem = {};
		$(".vc_tta-panel").each((i, obj) => {
			if ($elem.parents().closest(".vc_tta-panel").hasClass("vc_active") == false){
				$altelem = $(obj).find('.vc_tta-panel-title i');
				this.rotate($altelem, 0, 300);
			}
		} );
		if ($elem.parents().closest(".vc_tta-panel").hasClass("vc_active") == false){
			this.rotate($elem.find('i'), 180, 300);
		}
	}

	rotate($elem, angle, time)
	{
		$({deg: 0}).animate({deg: angle}, {
			duration: time,
			step: function(now) {
				$elem.css({
					transform: 'rotate(' + now + 'deg)'
				});
			}
		});
	}

}
let cx_app_instance = new cx_app();
})(jQuery);
